import { ArrowOutward, CheckCircleRounded, CloseOutlined, ErrorOutlineRounded, WarningAmberRounded } from '@mui/icons-material';
import { Alert, Grid, IconButton, Snackbar, SnackbarCloseReason, SnackbarProps, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import { customPaletteColors } from '../../themes/common';
import { useAccount } from 'wagmi';

export interface CustomSnackbarContent {
  type: 'success' | 'error' | 'warning' | 'info',
  title: string,
  subtitle?: string,
  cta?: {
    type: string,
    text: string,
  },
}
interface StyledSnackbarProps extends SnackbarProps {
  customContent: CustomSnackbarContent
  setOpen: (open: boolean) => void
}

const StyledSnackbar = styled(Snackbar)<SnackbarProps>(({ theme }) => {
  return ({
    backgroundColor: `${theme.palette.background.primary}`,
    padding: '0.5rem 1rem',
    borderRadius: 8,
    border: '1px solid',
    minWidth: '20rem',
    borderColor: `${theme.palette.background.border}`
  })
}
)

const AppliedStyle = (props: StyledSnackbarProps) => {
  const { customContent, setOpen } = props
  const { title, subtitle, cta, type } = customContent as CustomSnackbarContent
  const account = useAccount()
  const blockExplorer = account?.chain?.blockExplorers?.default


  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return <StyledSnackbar
    {...props}>
    <Grid container flexDirection={'column'} justifyContent={'flex-start'} alignItems={'center'} gap={0.5}>
      <Grid item container alignItems={'center'} sx={{ marginBottom: '-0.5rem' }}>
        <Alert
          iconMapping={{
            success: <CheckCircleRounded fontSize="inherit" sx={{ color: 'success.main' }} />,
            error: <ErrorOutlineRounded fontSize="inherit" sx={{ color: 'error.main' }} />,
            warning: <WarningAmberRounded fontSize="inherit" sx={{ color: 'warning.main' }} />,
          }}
          variant="outlined" severity={type} sx={{ border: 0, padding: 0 }}>
          <Typography variant='r' color='text.primary'>
            {title}
          </Typography>
        </Alert>
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
          sx={{ cursor: 'pointer', marginLeft: 'auto' }}
        >
          <CloseOutlined fontSize="small" />
        </IconButton>
      </Grid>
      {
        subtitle && (
          <Grid item container sx={{
            maxWidth: '30rem',
            maxHeight: '7rem',
            overflowY: 'scroll',
            // border: '0.5px solid',
            borderColor: '#5e5e5e',
            padding: '0.2rem 0.5rem',
            borderRadius: '4px',
            backgroundColor: `background.secondary`,
            scrollbarWidth: 'thin',
            boxSizing: 'content-box',
            scrollbarColor: `${customPaletteColors.brand.primary} ${customPaletteColors.brand.charcoal}`,
          }}>
            <Typography variant='s' color='text.secondary' sx={{
              maxWidth: '30rem',
              overflowWrap: 'break-word', boxSizing: 'border-box'
            }}>
              {subtitle}
            </Typography>
          </Grid>
        )
      }
      {
        cta && (
          <Grid item container>
            <Link style={{ color: customPaletteColors.brand.primary, textDecoration: 'none' }}
              target='_blank' to={`${blockExplorer?.url}/tx/${cta.text}`}>
              <Grid container alignItems={'center'}>
                <Typography variant='s' color='brand.primary'>
                  View Transaction&nbsp;
                </Typography>
                <ArrowOutward sx={{ fontSize: '1rem', color: 'brand.primary' }} />
              </Grid>
            </Link>
          </Grid>
        )
      }
    </Grid>
  </StyledSnackbar>
}

export default AppliedStyle